<template lang="pug">
    div.package(@click="choosePackage" @keyup.enter="choosePackage")
        div.imageWrapper(aria-hidden="true")
            img.packageImg(v-lazy="item.image" role="presentation")
            div.imageOverlay

        div.packageContent
            div
                div.packageTitle {{ item.title }}
                div.packagePriceWrapper
                    div.d-flex
                        div.packageCurrency(v-if="item.period") $
                        div.packagePrice {{ item.price }}
                    div.mb-2.mr-2(v-if="item.period") {{ ` / ${item.period}  ` }}

                    div.mb-2.mt-2.packageDescription {{ item.description }}
</template>

<script>
    import VueTypes from 'vue-types';
    import Button from '~components/Button';
    import { mapActions } from 'vuex';

    export default {
        props: {
            item: VueTypes.object.def({}),
            registrated: VueTypes.bool.def(false)
        },
        components: {
            ButtonComponent: Button
        },
        methods: {
            ...mapActions('payments', ['setPackageType']),

            /**
             * Set Package type
             * @param {string} val
             */
            choosePackage() {
                this.setPackageType(this.item.type);
                if (this.registrated) {
                    return this.$router.push({
                        name: 'dashboard.paymentInformation'
                    });
                }
                this.$router.push({
                    name: 'auth.registration'
                });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../assets/style/_variables.styl'

    .package
        position: relative
        margin-top: 15px
        padding: 10px 16px
        border-radius: 10px
        overflow: hidden

        &:hover
            cursor: pointer

            .packageImg
                transform: scale(1.15) translate(-50%, -50%)

    .packageContent
        position: relative
        z-index: 3
        display: flex
        align-items: flex-end
        justify-content: space-between


    .imageWrapper
        width: 106%
        height: 106%
        position: absolute
        top: -3%
        left: -3%
        z-index: 1

    .imageOverlay
        position: absolute
        width: 100%
        height: 100%
        background-color: rgba(#000,  0.1)
        z-index: 2


    .packageImg
        position: absolute
        display: block
        min-width: 100%
        min-width: 100%
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)
        transform-origin: 50% 50%
        transition: transform 6s
        z-index: 1

    .packageLine
        width: 40px
        height: 4px
        border-radius: 5px
        background-color: $theme.white

    .packageTitle
        margin-top: 5px
        font-size: 27px;
        line-height: 27px;
        font-weight: 300

    .packagePriceWrapper
        display: flex
        align-items: flex-end
        margin-top: 10px

    .packagePrice
        font-size: 45px
        font-weight: 700

    .packageDescription
        max-width: 230px
        font-size: 13px

    .packageTrial
        position: absolute
        top: 18px
        right: 0
        font-size: 13px
        padding: 3px 10px 3px 60px
        background: linear-gradient(90deg, rgba(0, 0, 0, 0) 20%,#7096D2  87.4%)
        z-index: 2

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .package
            padding: 8px

        .packageTitle
            line-height: 22px
            font-size: 22px

        .packagePrice
            font-size: 34px;
</style>
